module.exports = __webpack_public_path__ + "img/res02.1a481d95.png";